import { FormikProps, useFormik } from "formik";
import { BasicDetailsFormProps } from "@utils/types";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useNavigate } from "react-router";

const useBasicDetailsScreen = () => {
  const navigate = useNavigate();

  const userDetails = useSelector(
    (state: RootState) => state.appLayout.userDetails as any
  );

  const hostDetails = useSelector(
    (store: RootState) => store.hostForm.hostBasicDetails
  ) as any;

  const formik: FormikProps<BasicDetailsFormProps> =
    useFormik<BasicDetailsFormProps>({
      initialValues: {
        userType: userDetails?.userType || "Host",
        fullName: hostDetails?.fullName || "",
        emailId: hostDetails?.emailId || userDetails?.emailId || "",
        mobileNumber: userDetails?.mobileNumber || "",
        gender: hostDetails?.gender || "Male",
        age: hostDetails?.age || "",
        address: hostDetails?.address || "",
        pincode: hostDetails?.pincode || "",
        district: hostDetails?.district || "",
        state: hostDetails?.state || "",
        experience: hostDetails?.experience || "",
        currentstate: hostDetails?.currentstate || "",
        currentdistrict: hostDetails?.currentdistrict || "",
        primaryNumber: hostDetails?.primaryNumber || "",
        secondaryNumber: hostDetails?.secondaryNumber || "",
      },
      validationSchema: Yup.object({
        userType: Yup.string().required("User Type is required"),
        fullName: Yup.string().required("Full Name is required"),
        emailId: Yup.string()
          .email("Invalid email address")
          .required("Email is required"),
        mobileNumber: Yup.string()
          .matches(/^\d{10}$/, "Mobile Number must be 10 digits")
          .required("Mobile Number is required"),
        gender: Yup.string()
          .oneOf(["Male", "Female", "Other"], "Invalid Gender")
          .required("Gender is required"),
        age: Yup.number()
          .typeError("Age must be a number")
          .min(1, "Age must be greater than 0")
          .max(120, "Age must be less than or equal to 120")
          .required("Age is required"),
        address: Yup.string().required("Address is required"),
        pincode: Yup.string()
          .matches(/^\d{6}$/, "PIN Code must be 6 digits")
          .required("PIN Code is required"),
        district: Yup.string().required("District is required"),
        state: Yup.string().required("State is required"),
        currentdistrict: Yup.string().required("Current District is required"),
        currentstate: Yup.string().required("Current State is required"),
        experience: Yup.string()
          .matches(/^\d+$/, "Experience must be a number")
          .required("Experience is required"),
        primaryNumber: Yup.string()
          .matches(/^\d{10}$/, "Primary Number must be 10 digits")
          .required("Primary Number is required"),
        secondaryNumber: Yup.string()
          .matches(/^\d{10}$/, "Secondary Number must be 10 digits")
          .notRequired(),
      }),
      enableReinitialize: true,
      onSubmit: (values) => {
        navigate("/kyc");
      },
    });

  return { formik };
};

export default useBasicDetailsScreen;
